






















































































import { Component } from 'vue-property-decorator';
import colors, { ColorConfig } from '@/config/colors';
import { colors as vuetifyColor } from 'vuetify/lib';
import LikeIcon from '@/components/Helper/Icon/Svg/LikeIcon.vue';
import AddReactionBtn from '@/components/ViewComponent/Thanks/ThanksMessage/ThanksMessageItem/AddReactionBtn.vue';
import ReactionList from '@/components/ViewComponent/Thanks/ThanksMessage/ThanksMessageItem/ReactionList.vue';
import UserAvatar from '@/components/Helper/UserAvatar.vue';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import EditThanksCommentItem from '@/components/ViewComponent/Thanks/ThanksMessage/ThanksMessageItem/EditThanksCommentItem.vue';
import ThanksMessageItemMixin from './thanks-message-item.mixin';

@Component<ThanksMessageItemPc>({
  components: {
    EditThanksCommentItem,
    UserAvatar,
    ReactionList,
    AddReactionBtn,
    LikeIcon,
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class ThanksMessageItemPc extends ThanksMessageItemMixin {
  currentStaff!: StaffEntity;
  colors: ColorConfig = colors;
  vuetifyColor = vuetifyColor;

  isShow = false;
  plagShowMore = false;

  created() {
    this.plagShowMore = this.gift.message.length > 100;
  }

  showModal() {
    if (this.currentStaff.id !== this.gift.staffFromId) return;
    this.isShow = true;
  }

  toggler() {
    this.plagShowMore = !this.plagShowMore;
  }

  /**
   * Update the reaction in the post after adding the post's reaction to the database.
   * @param reaction 
   */
  updateReaction(reaction) {
    const existingReaction = this.gift.reactions.find(item => item.emoticonId === reaction.emoticonId);
    // Has the reaction in the post been checked if it already exists?
    if (existingReaction) {
      // Increase the quantity by 1
      existingReaction.count = Number(existingReaction.count) + 1;
    } else {
      // Push into reactions on post
      this.gift.reactions.push(reaction);
    }
    // Marked as reacted
    this.gift.hasReacted = true;
  }
}
